export default "__VITE_ASSET__AW6OvhuY__"